import { SettingsValueProps } from './components/settings/type'
import { icons, layout } from './theme/tokens.generated'

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_BACKOFFICE_URL || ''

// LAYOUT
// ----------------------------------------------------------------------
//
// The shell reads the token source. These used to be 280 / 88 / 64, typed
// here and nowhere else, while `beast.tokens.json` published 240 / 64 / 60
// and every other surface followed it. One set of numbers, in one place.

export const HEADER = {
  MOBILE_HEIGHT: layout.headerHeight,
  MAIN_DESKTOP_HEIGHT: layout.headerHeight,
  DASHBOARD_DESKTOP_HEIGHT: layout.headerHeight,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: layout.headerHeight,
}

export const NAVBAR = {
  BASE_WIDTH: layout.sidebarWidth,
  DASHBOARD_WIDTH: layout.sidebarWidth,
  DASHBOARD_COLLAPSE_WIDTH: layout.sidebarRailWidth,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: layout.controlHeight,
  DASHBOARD_ITEM_SUB_HEIGHT: layout.controlHeight,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: layout.controlHeightSmall,
}

export const ICON = {
  // The 40px nav item's step. 20 beside a 14px label reads chunky at 1.4x the
  // text size; 18 lands at 1.29x, which is why the grid has the step at all.
  NAVBAR_ITEM: icons.sizes.control,
  NAVBAR_ITEM_HORIZONTAL: icons.sizes.toolbar,
}

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeLayout: 'horizontal',
}
